import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "fi-icon-regular-requiring-po",
  "use": "fi-icon-regular-requiring-po-usage",
  "viewBox": "0 0 26 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 26 18\" id=\"fi-icon-regular-requiring-po\">\n  <text id=\"fi-icon-regular-requiring-po_Page_1\" data-name=\"Page 1\" transform=\"translate(0 14)\" font-size=\"18\" font-family=\"AvenirLTStd-Heavy, Avenir LT Std\" font-weight=\"800\" letter-spacing=\"-0.01em\"><tspan x=\"0\" y=\"0\">PO</tspan></text>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol